import React from 'react';
import { TagTable } from '@tag/tag-components-react-v2';

export type EventTableColumns = {
  name: string;
  description: string;
  parameters: string;
};
export type Props = {
  data: EventTableColumns[];
};
export const ComponentEvents: React.FC<Props> = ({ data }) => {
  return (
    <div>
      <TagTable
        columns={[
          {
            name: 'name',
            caption: 'Name',
          },
          {
            name: 'description',
            caption: 'Description',
          },
          {
            name: 'parameters',
            caption: 'Parameters',
          },
        ]}
        data={data}
      />
    </div>
  );
};
